import React, { useState, useEffect } from "react";
import TextInput from "../fields/TextInput";
import { Switch, Typography, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  carUploadImages,
  decreaseStep,
  increaseStep,
  setCarImagesResponse,
  storeCarInsurance,
} from "../../redux/Slice/formSlice";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { scroller } from "react-scroll";
import { MdOutlineFileUpload } from "react-icons/md";
const RentCharges = () => {
  const dispatch = useDispatch();
  // const PersonalDetails = useSelector((state) => state.form.PersonalDetails);
  // const carDetails = useSelector((state) => state.form.carDetails);
  // const driverDetails = useSelector((state) => state.form.driverDetails);
  const carInsurance = useSelector((state) => state.form.carInsurance);
  // const location = useSelector((state) => state.form.location);
  // const [withDriver, setDriverChecked] = useState(false);
  const step = useSelector((state) => state?.form?.step);
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const [rent, setRent] = useState("");
  const currentDate = new Date();
  const [expiryDate, setexpiryDate] = useState(null);
  const [insuranceDetail, setInsuranceDetail] = useState({
    companyName: "",
    policyNumber: "",
    diskImage: "",
  });
  const [errmsg, setErrMsg] = useState({
    companyName: "",
    policyNumber: "",
    rent: "",
    insuranceAvailable: "",
    expiryDate: "",
    diskImage: "",
  });
  const [insuranceAvailable, setChecked] = useState(
    carInsurance?.insuranceAvailable || false
  );

  const expiryDateChange = (newValue) => {
    setexpiryDate(newValue);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setErrMsg((prev) => ({
      ...prev,
      insuranceAvailable: "",
    }));
  };

  const handleInput = (event) => {
    const policyRegex = /^[a-zA-Z0-9]+$/;
    const { name, value, type, files } = event.target;
    if (name) {
      setErrMsg((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
    if (name === "policyNumber") {
      if (value === "" || policyRegex.test(value)) {
        setInsuranceDetail((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      }
    }
    if (type === "file") {
      const file = files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          // Store both base64 data and filename in the state
          setInsuranceDetail((prevFormData) => ({
            ...prevFormData,
            [name]: { base64: reader.result, filename: file.name },
          }));
          try {
            let formData = new FormData();
            formData.append("type", name);
            formData.append("image", file);

            dispatch(carUploadImages(formData)).then((res) => {
              dispatch(setCarImagesResponse({ [name]: res?.payload.data }));
            });
          } catch (error) {}
        };
        reader.readAsDataURL(file);
      }
    } else
      setInsuranceDetail((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
  };
  useEffect(() => {
    setErrMsg((prev) => ({
      ...prev,
      expiryDate: "",
    }));
  }, [expiryDate]);

  useEffect(() => {
    setInsuranceDetail({
      ...insuranceDetail,
      companyName: carInsurance?.companyName,
      policyNumber: carInsurance?.policyNumber,
      diskImage: carInsurance?.diskImage,
    });
    setRent(carInsurance?.pricePerDay);
    if (carInsurance?.expiryDate)
      setexpiryDate(dayjs(carInsurance?.expiryDate, "MM-DD-YYYY"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleIncrease = () => {
    const isAlphanumeric = /^[a-zA-Z0-9]+$/.test(insuranceDetail.policyNumber);
    if (insuranceAvailable) {
      let newErrMsg = {};
      let errorCheck = 0;
      if (insuranceDetail.companyName === "") {
        newErrMsg = { ...newErrMsg, companyName: "Please Enter Company Name" };
        errorCheck = 1;
      }
      if (insuranceDetail.policyNumber === "") {
        newErrMsg = {
          ...newErrMsg,
          policyNumber: "Please Enter policy Number",
        };
        errorCheck = 1;
      } else if (insuranceDetail.policyNumber.length < 6) {
        newErrMsg = {
          ...newErrMsg,
          policyNumber: "Policy number must be at least 6 characters long",
        };
        errorCheck = 1;
      } else if (insuranceDetail.policyNumber.length > 12) {
        newErrMsg = {
          ...newErrMsg,
          policyNumber: "Policy number must be at most 12 characters long",
        };
      } else if (!isAlphanumeric) {
        newErrMsg = {
          ...newErrMsg,
          policyNumber: "Policy number must contain only letters and numbers",
        };
        errorCheck = 1;
      }
      if (!rent) {
        newErrMsg = { ...newErrMsg, rent: "Please Enter Rent" };
        errorCheck = 1;
      } else if (rent <= 0) {
        newErrMsg = { ...newErrMsg, rent: "Rent must be greater then 0" };
        errorCheck = 1;
      }
      if (expiryDate === null) {
        newErrMsg = {
          ...newErrMsg,
          expiryDate: "Please Select Expiry date",
        };
        errorCheck = 1;
      } else if (expiryDate && expiryDate <= currentDate) {
        newErrMsg = {
          ...newErrMsg,
          expiryDate: "Please select a date in the future",
        };
        errorCheck = 1;
      }
      if (insuranceDetail?.diskImage === "" || !insuranceDetail?.diskImage) {
        newErrMsg = {
          ...newErrMsg,
          diskImage: "Please Upload Image",
        };
        errorCheck = 1;
      }
      if (Object.keys(newErrMsg).length > 0) {
        const firstErrorField = Object.keys(newErrMsg)[0];

        scroller.scrollTo(firstErrorField, {
          duration: 300,
          delay: 0,
          smooth: "easeInOutQuart",
          offset: -150, // Adjust offset here
        });
      }
      setErrMsg(newErrMsg);
      // if (insuranceDetail.companyName === "" || insuranceDetail.policyNumber === "" || !rent) {
      if (errorCheck === 1) {
        return;
      } else {
        // Assuming PersonalDetails, carDetails, driverDetails, and carInsurance are defined somewhere above
        // const formData = new FormData();

        // // Append personal details
        // if (PersonalDetails) {
        //   formData.append("role", 1);
        //   formData.append("personalName", PersonalDetails.fullName || "");
        //   formData.append("userId", PersonalDetails.userId || "");
        //   formData.append("address", PersonalDetails.address || "");
        //   formData.append("identityFront", PersonalDetails.identityFront || "");
        //   formData.append("identityBack", PersonalDetails.identityBack || "");
        // }

        // // Append car details
        // if (carDetails) {
        //   formData.append("maker", carDetails.carMake || "");
        //   formData.append("model", carDetails.carModel || "");
        //   formData.append("carCategory", carDetails.carType || "");
        //   formData.append("yearOfManufacture", carDetails.manufactureYr || "");
        //   formData.append(
        //     "registrationNumber",
        //     carDetails.registrationNum || ""
        //   );
        //   formData.append("numberOfSeats", carDetails.seat || "");
        //   formData.append("mileage", carDetails.mileage || "");
        //   formData.append("fuelType", carDetails.fuelType || "");
        //   formData.append("motor", carDetails.motor || "");
        //   formData.append("topSpeed", carDetails.speed || "");
        //   formData.append("power", carDetails.power || "");
        //   formData.append("features", carDetails.carFeature || "");
        //   formData.append("carLocation", carDetails.carLocation || "");
        //   formData.append("lat", location?.lat || "");
        //   formData.append("long", location?.lng || "");
        //   formData.append("frontImage", carDetails.carFrontImg || "");
        //   formData.append("seatsImage", carDetails.carSeatsImg || "");
        //   formData.append("dashboardImage", carDetails.carDashboardImg || "");
        //   formData.append("chassisImage", carDetails.carChassisImg || "");
        //   formData.append("backImage", carDetails.carBackImg || "");
        //   formData.append("leftImage", carDetails.carLeftImg || "");
        //   formData.append("rightImage", carDetails.carRightImg || "");
        //   formData.append("numberPlateImg", carDetails.numberPlateImg || "");
        //   formData.append("gpsAvaiblity", carDetails.gpsAvaiblity || false);
        // }

        // // Append driver details
        // if (driverDetails) {
        //   formData.append("driverName", driverDetails.fullName || "");
        //   formData.append("age", driverDetails.age || "");
        //   formData.append("phoneNumber", driverDetails.phone || "");
        //   formData.append("email", driverDetails.email || "");
        //   formData.append("rent", driverDetails.driverRent || "");
        //   formData.append("identityCardFrontSide", driverDetails.IDfront || "");
        //   formData.append("identityCardBackSide", driverDetails.IDback || "");
        //   formData.append("licenceCard", driverDetails.licenceImg || "");
        //   formData.append(
        //     "licenceIssueDate",
        //     driverDetails.licenceIssueDate || ""
        //   );
        //   formData.append(
        //     "licenceExpiryDate",
        //     driverDetails.licenceExpiryDate || ""
        //   );
        //   formData.append("withDriver", driverDetails.withDriver || false);
        // }

        // // Append insurance details
        // if (carInsurance) {
        //   formData.append("pricePerDay", carInsurance.pricePerDay || "");
        //   formData.append("companyName", carInsurance.companyName || "");
        //   formData.append("diskImage", carInsurance.diskImage || "");
        //   formData.append("policyNumber", carInsurance.policyNumber || "");
        //   formData.append("expiryDate", carInsurance.expiryDate || "");
        //   formData.append(
        //     "insuranceAvailable",
        //     carInsurance.insuranceAvailable || false
        //   );
        // }

        // Dispatch action
        // dispatch(addCar({ data: formData }));
        dispatch(increaseStep());

        const updatedCarInsurance = {
          ...insuranceDetail,
          pricePerDay: rent,
          expiryDate: expiryDate ? expiryDate.format("MM-DD-YYYY") : "",
          insuranceAvailable: insuranceAvailable,
        };

        dispatch(storeCarInsurance(updatedCarInsurance));
        scrollToTop();
      }
    } else {
      let newErrMsg = {};
      let errorCheck = 0;
      if (!rent) {
        newErrMsg = { ...newErrMsg, rent: "Please Enter Rent" };
        errorCheck = 1;
      } else if (rent <= 0) {
        newErrMsg = { ...newErrMsg, rent: "Rent must be greater then 0" };
        errorCheck = 1;
      }
      if (insuranceAvailable === false) {
        newErrMsg = {
          ...newErrMsg,
          insuranceAvailable: "Please Enable Car Insurance",
        };
        errorCheck = 1;
      }
      if (Object.keys(newErrMsg).length > 0) {
        const firstErrorField = Object.keys(newErrMsg)[0];
        scroller.scrollTo(firstErrorField, {
          duration: 300,
          delay: 0,
          smooth: "easeInOutQuart",
          offset: -150, // Adjust offset here
        });
      }
      setErrMsg(newErrMsg);
      // if (!rent) {
      if (errorCheck === 1) {
        return;
      } else {
        dispatch(increaseStep());
        scrollToTop();
      }
    }
  };
  const numberRegex = /^\d+$/;
  const rentChangeHandler = (event) => {
    const { value, name } = event.target;
    if (numberRegex.test(value) || value === "") setRent(value);
    if (name === "rent") {
      setErrMsg((pre) => ({
        ...pre,
        [name]: "",
      }));
    }
  };

  return (
    <>
      <div className="car-list-form">
        <h3 className="accentColor mt-5">Please Enter Rent Information</h3>
        <div className="d-flex justify-content-between gap-5 align-items-end flex-wrap flex-grow-1 gap-5 flex-wrap">
          <div className="">
            <TextInput
              type="number"
              labelName="Rent per day in K:"
              id="carrent"
              placeholder="K"
              size="small"
              name="rent"
              value={rent}
              onChange={rentChangeHandler}
              error={!!errmsg?.rent}
              helperText={errmsg?.rent}
            />
          </div>

          {/* <div className="flex-fill">
            <div className="d-flex align-items-center justify-content-center ">
              <h5
                className="secondaryColor pointer"
                onClick={() => setDriverChecked(!withDriver)}
              >
                With Driver
              </h5>
              <Switch
                checked={withDriver}
                onChange={() => setDriverChecked(!withDriver)}
                inputProps={{ "aria-label": "Driver Switch" }}
              />
            </div>
          </div> */}
        </div>
        <div className="row mb-4 g-3 m-0">
          {/* <div className="col-md-3">
            <TextInput
              type="number"
              labelName="Rent per day in K:"
              id="carrent"
              placeholder="K"
              size="small"
              name="rent"
              value={rent}
              onChange={rentChangeHandler}
              error={!!errmsg?.rent}
              helperText={errmsg?.rent}
            />
          </div> */}

          <div className="d-flex align-items-center pb-3">
            <h5
              className="secondaryColor pointer"
              onClick={() => {
                setChecked(!insuranceAvailable);
              }}
            >
              Car Insurance
            </h5>
            <Switch
              name="insuranceAvailable"
              checked={insuranceAvailable}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
            />
            {errmsg.insuranceAvailable && (
              <div className="text-danger">{errmsg.insuranceAvailable}</div>
            )}
          </div>

          {insuranceAvailable ? (
            <>
              <p className="text-center car-list-form-p">Insurance Details</p>
              <div className="row my-3 g-3 m-0">
                <div className="col-md-4 col-lg-3">
                  <TextInput
                    type="text"
                    labelName="Company Name:"
                    id="insuranceCompany"
                    placeholder="Enter Company Name"
                    size="small"
                    name="companyName"
                    value={insuranceDetail?.companyName}
                    onChange={handleInput}
                    error={!!errmsg?.companyName}
                    helperText={errmsg?.companyName}
                  />
                </div>
                <div className="col-md-4 col-lg-3">
                  <TextInput
                    type="text"
                    labelName="Policy Number:"
                    id="policyNumber"
                    placeholder="Enter Policy Number"
                    size="small"
                    name="policyNumber"
                    value={insuranceDetail?.policyNumber}
                    onChange={handleInput}
                    error={!!errmsg?.policyNumber}
                    helperText={errmsg?.policyNumber}
                  />
                </div>

                <div className="col-md-4 col-lg-3">
                  <label className="input-label my-2 d-block">
                    Expiry date:<span style={{ color: "red" }}>*</span>
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      sx={{ width: "100%" }}
                      // disablePast
                      minDate={dayjs().add(1, "day")}
                      value={expiryDate}
                      name="expiryDate"
                      onChange={expiryDateChange}
                      renderInput={(params) => (
                        <TextField {...params} size="small" />
                      )}
                      format="MM-DD-YYYY"
                      slotProps={{
                        textField: { size: "small", readOnly: true },
                      }}
                    />
                    {errmsg.expiryDate && (
                      <Typography variant="caption" component="p" color="error">
                        {errmsg.expiryDate}
                      </Typography>
                    )}
                  </LocalizationProvider>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs} >
                                        <DatePicker
                                            value={expiryDate}
                                            onChange={(newValue) => setexpiryDate(newValue)}
                                            slotProps={{ textField: { size: 'small' } }}
                                            sx={{ width: "100%" }}
                                            format='DD-MM-YYYY'
                                        />
                                    </LocalizationProvider> */}
                </div>
                <div className="col-md-4 col-lg-3" name="diskImage">
                  <p className="input-label my-2">
                    Disk Image:<span className="text-danger">*</span>
                  </p>
                  <div className="file-input">
                    <label
                      className={`file-input__label py-8 ${
                        errmsg?.diskImage ? "error" : null
                      }`}
                      htmlFor="diskImage"
                    >
                      <input
                        // disabled={editCarID}
                        type="file"
                        accept="image/*"
                        name="diskImage"
                        id="diskImage"
                        className="file-input__input"
                        onChange={handleInput}
                      />
                      {insuranceDetail?.diskImage ? (
                        <img
                        alt='car disk'
                          className="upload-doc mx-auto pointor"
                          // src={`${insuranceDetail?.diskImage.base64}`}
                          src={
                            insuranceDetail?.diskImage.base64
                              ? insuranceDetail?.diskImage.base64
                              : `${baseURL}${insuranceDetail?.diskImage}`
                          }
                        />
                      ) : (
                        <>
                          <MdOutlineFileUpload className="upload-icon" />
                          <span className="text-truncate">Upload</span>
                        </>
                      )}
                    </label>
                    <p className="location-err">{errmsg.diskImage}</p>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
      {step < 4 && (
        <div className="d-flex justify-content-between">
          {step > 0 && (
            <>
              <button
                onClick={() => {
                  dispatch(decreaseStep());
                  scrollToTop();
                }}
                type="button"
                className="btn d-none d-lg-block  px-5 img-btn mt-5 primaryColor"
              >
                {" "}
                Back{" "}
              </button>
              <button
                onClick={() => {
                  dispatch(decreaseStep());
                  scrollToTop();
                }}
                type="button"
                className="btn d-block d-lg-none px-3 img-btn mt-5 primaryColor"
              >
                <HiOutlineArrowLeft />
              </button>
            </>
          )}
          {step < 3 ? (
            <>
              <button
                onClick={() => {
                  handleIncrease();
                  scrollToTop();
                }}
                type="button"
                className="btn d-none d-lg-block ms-auto px-5 img-btn mt-5 primaryColor"
              >
                {" "}
                Continue{" "}
              </button>
              <button
                onClick={() => {
                  handleIncrease();
                  scrollToTop();
                }}
                type="button"
                className="btn d-block d-lg-none ms-auto px-3 img-btn mt-5 primaryColor"
              >
                {" "}
                <HiOutlineArrowRight />{" "}
              </button>
            </>
          ) : (
            <button
              onClick={(e) => {
                handleIncrease();
                scrollToTop();
              }}
              type="submit"
              className="btn px-5 img-btn mt-5 primaryColor"
            >
              Continue
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default RentCharges;
